var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment-plans gantt-scroll",
      style: { width: _vm.width, height: "100vh" },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          {
            staticClass: "closer",
            style: { width: "24px", height: "24px" },
            on: { click: _vm.close },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M14.9697 16.0303C15.2626 16.3232 15.7374 16.3232 16.0303 16.0303C16.3232 15.7374 16.3232 15.2626 16.0303 14.9697L13.0607 12L16.0303 9.03034C16.3232 8.73744 16.3232 8.26257 16.0303 7.96968C15.7374 7.67678 15.2626 7.67678 14.9697 7.96968L12 10.9393L9.03033 7.96967C8.73744 7.67678 8.26256 7.67678 7.96967 7.96967C7.67678 8.26256 7.67678 8.73744 7.96967 9.03033L10.9393 12L7.96967 14.9697C7.67678 15.2626 7.67678 15.7374 7.96967 16.0303C8.26256 16.3232 8.73744 16.3232 9.03033 16.0303L12 13.0607L14.9697 16.0303Z",
                    fill: "#333333",
                  },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "head", staticClass: "head" }, [
          _c("div", { staticClass: "main-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locales("plans_popup_title")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: ["period-tabs", _vm.isAnnual ? "annual" : "month"] },
            [
              _c(
                "div",
                {
                  staticClass: "tab annually",
                  on: {
                    click: function ($event) {
                      return _vm.toggleAnnual(true)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { class: ["save-item", _vm.isAnnual ? "dnone" : ""] },
                    [_c("discount-svg")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.locales("plans_annually_locale"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab monthly",
                  on: {
                    click: function ($event) {
                      return _vm.toggleAnnual(false)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.locales("plans_monthly_locale")) +
                      "\n        "
                  ),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _c(
            "div",
            { ref: "plansSection", staticClass: "plans" },
            _vm._l(_vm.plans, function (plan, index) {
              return _c("plan-item", {
                key: index,
                attrs: {
                  plan: plan,
                  "is-annual": _vm.isAnnual,
                  "is-popup": false,
                  "number-of-plan": _vm.numberOfPlanItems,
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { ref: "studentsSection", staticClass: "students-container" },
            [
              _c("div", { staticClass: "students" }, [
                _c("div", { staticClass: "students__inner" }, [
                  _c("p", { staticClass: "students__title" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.locales("plans_students_title")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "students__desc",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.locales("plans_students_description")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "students__btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--transparent",
                        on: { click: _vm.studentsClick },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.locales("learn_more")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "features",
              staticClass: "features border-wrapper",
              attrs: { id: "features" },
            },
            [
              _c("div", { ref: "table", staticClass: "table" }, [
                _c("div", { ref: "tableHead", staticClass: "table-head" }, [
                  _c(
                    "div",
                    { ref: "tableHeadTitle", staticClass: "table-head-title" },
                    [
                      _c("div", { staticClass: "features-title title-h2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.locales("pricing_plans_features_table_head")
                            ) +
                            "\n            "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "head-plans-wrapper" },
                    _vm._l(_vm.plans, function (plan, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class: ["table-plan-cell head-cell", plan.name],
                        },
                        [
                          plan.name !== "enterprise"
                            ? _c("div", { staticClass: "inner-info" }, [
                                _c("div", { staticClass: "plan-name" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.locales(plan.name + "_plan_locale")
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "price-desc" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s("$ " + _vm.currentPrice(plan)) +
                                      "\n                  "
                                  ),
                                ]),
                              ])
                            : _c("div", { staticClass: "inner-info" }, [
                                _c("div", { staticClass: "plan-name" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.locales(plan.name + "_plan_locale")
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "price-desc" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.locales("lets_talk_locale")) +
                                      "\n                  "
                                  ),
                                ]),
                              ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "tableBody",
                    class:
                      "table-body " + (this.isCollapsed ? "collapsed" : ""),
                  },
                  _vm._l(_vm.featuresTable, function (group, index) {
                    return _c("table-group", {
                      key: index,
                      ref: "tableGroup",
                      refInFor: true,
                      attrs: { plans: _vm.plans, group: group },
                    })
                  }),
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "tableCollapse",
                  class:
                    "table-collapse " + (this.isCollapsed ? "collapsed" : ""),
                  on: {
                    click: function ($event) {
                      return _vm.collapseTable()
                    },
                  },
                },
                [
                  _c(
                    "button",
                    [
                      _vm._v(
                        _vm._s(
                          "" +
                            (this.isCollapsed
                              ? _vm.locales("pricing_table_collapse_hide")
                              : _vm.locales("pricing_table_collapse_show"))
                        ) + " \n            "
                      ),
                      _c("svgImage", {
                        attrs: { name: "pricing-table-collapse-icon" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { ref: "faq", staticClass: "faq" }, [
            _c("div", { staticClass: "faq-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.locales("faq_plans_locales")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "faq-list" },
              _vm._l(_vm.faqConfig, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "faq-item",
                    attrs: { "data-key": item.key },
                    on: { click: _vm.showAnswer },
                  },
                  [
                    _c("div", { staticClass: "question" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.question) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "check-icon" },
                      [
                        _c("webix-ui", {
                          attrs: { config: _vm.icons.checkIcon },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "answer",
                      domProps: { innerHTML: _vm._s(item.answer) },
                    }),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { ref: "footer", staticClass: "contact-footer" }, [
            _c("div", { staticClass: "footer-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.locales("plans_popup_footer_title")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "contact-us",
              domProps: {
                innerHTML: _vm._s(_vm.locales("footer_contact_link_locale")),
              },
              on: { click: _vm.chatClick },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }